import { BehaviorSubject, Observable, Subject } from 'rxjs';

export abstract class Store<T> {
  
  private readonly _state$: BehaviorSubject<T>;
  readonly state$: Observable<T>;
  get state(): T { return this._state$.getValue(); }

  private readonly _destroyed$ = new Subject<void>();
  protected readonly destroyed$ = this._destroyed$.asObservable();

  private readonly initialState: T;

  constructor(initialState: T) {
    this._state$ = new BehaviorSubject<T>(initialState);
    this.state$ = this._state$.asObservable();
    this.initialState = initialState;
  }

  destroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
    this.update(() => this.initialState);
  }

  protected update(...updates: UpdateFn<T>[]): void {
    const state = this.state;
    const newState = updates.reduce((x, f) => f(x), state);
    
    if (state === newState) {
      return;
    }

    this._state$.next(newState);
  }
}

export type UpdateFn<T> = (state: T) => T;
